import { useDeviceInfo } from "@swa-ui/browser";

import { createSourceBreakpoints } from "../createSourceBreakpoints/createSourceBreakpoints";

/**
 * Accepts a base source string and produces a list of breakpoints based on the
 * media queries provided by the DeviceInfoProvider.
 * @param {string} source The base source string of the asset
 * @returns An array of objects with media queries and sources
 */
export const useSourceBreakpoints = (source) => {
  const { mediaQueries } = useDeviceInfo();

  return createSourceBreakpoints(source, mediaQueries);
};
